<template>
  <div>
    <div class="mainBox pay-page" :class="{ 'pay-page--coupon-open': visible, 'pay-page--dual-footer': payFooterDualLayout }">
      <!-- 顶部 banner（槽位 source 配置决定广告商） -->
      <div
        class="pay-banner-card pay-banner-card--top"
        :class="{ 'pay-banner-card--pending': !payTopBannerLoaded }"
        v-if="adConfigReady && !isCloseAD && hasPayTopBanner && !payTopBannerFailed"
        v-show="!visible"
      >
        <div class="pay-banner">
          <pay-banner-ad
            position="EXIT_ORDER_TOP_BANNER"
            @loaded="payTopBannerLoaded = true"
            @failed="payTopBannerFailed = true"
          />
        </div>
      </div>

      <div class="pay-page-body">
        <div class="pay-order-card">
          <div class="pay-plate-row">
            <div class="pay-plate-left">
              <span class="pay-plate-number">{{ plate_number }}</span>
              <span class="pay-plate-cate">{{ plateNumFormatterCate(cateID, plate_number) }}</span>
            </div>
            <span class="pay-home-link" @click="goHome">回到首页</span>
          </div>

          <div class="pay-info-grid" v-if="!onlyEscape">
            <!-- <div class="pay-info-cell">
              <span class="pay-info-label">车场名称</span>
              <span class="pay-info-value">{{ parkname || '停车场' }}</span>
            </div> -->
            <div class="pay-info-cell">
              <span class="pay-info-label">入场时间</span>
              <span class="pay-info-value pay-info-value--bold">{{ start_time | filterTimeShort }}</span>
            </div>
            <div class="pay-info-cell">
              <span class="pay-info-label">停车时长</span>
              <span class="pay-info-value pay-info-value--bold">{{ parked_time | formatParkDuration }}</span>
            </div>
            <div class="pay-info-cell">
              <span class="pay-info-label">停车费用</span>
              <span class="pay-info-value pay-info-value--bold">{{ (payablefee / 100).toFixed(2) }} 元</span>
            </div>
            <div v-if="Number(lastDiscoutPure) > 0" class="pay-info-cell">
              <span class="pay-info-label">场内已优惠金额</span>
              <span class="pay-info-value pay-info-value--bold">{{ (lastDiscoutPure / 100).toFixed(2) }} 元</span>
            </div>
            <div v-if="Number(lastPaidTotal) > 0" class="pay-info-cell">
              <span class="pay-info-label">场内已付金额</span>
              <span class="pay-info-value pay-info-value--bold">{{ (lastPaidTotal / 100).toFixed(2) }} 元</span>
            </div>
          </div>
          <div class="pay-info-grid" v-else>
            <div class="pay-info-cell pay-info-cell--full">
              <span class="pay-info-label">停车费用</span>
              <span class="pay-info-value pay-info-value--bold">{{ (payablefee / 100).toFixed(2) }} 元</span>
            </div>
          </div>
        </div>

        <div class="pay-summary-card">
          <div class="pay-detail-list">
            <div v-if="showCouponRow" class="pay-detail-item" @click="Price1()">
              <span class="pay-detail-label">优惠券</span>
              <span class="pay-detail-value pay-detail-value--coupon">
                {{ couponDisplayText }}
                <van-icon size="0.16rem" color="#999" name="arrow" />
              </span>
            </div>
            <div v-if="showEscapeRow" class="pay-detail-item">
              <span class="pay-detail-label" style="display:flex;align-items:center;">
                <van-checkbox
                  v-if="check_out_mode && check_out_mode === 1"
                  shape="square"
                  v-model="escapeChecked"
                  @change="escapeCheckedChange()"
                ></van-checkbox>
                欠费
              </span>
              <span
                class="pay-detail-value pay-detail-value--escape"
                @click="openEscapeOrder()"
              >
                {{ (escapeOrderFee / 100).toFixed(2) }} 元
                <span style="margin-left: 4px;">（{{ count_zero }}笔）</span>
                <van-icon size="0.16rem" color="#999" name="arrow" />
              </span>
            </div>
            <div
              class="pay-detail-item pay-detail-item--comment"
              v-if="showPayCommentRow"
            >
              <span class="pay-detail-label">备注</span>
              <span class="pay-detail-value">{{ comment }}</span>
            </div>
            <div class="pay-detail-item pay-detail-item--total">
              <span class="pay-detail-label">小计</span>
              <span class="pay-detail-total-price">{{ (actually_paid / 100).toFixed(2) }} 元</span>
            </div>
          </div>
        </div>

        <!-- 底部广告栈：P云 → 券包 → 花瓣欠费 -->
        <div class="pay-ad-stack" v-show="!visible">
          <div
            class="pay-banner-card"
            :class="{ 'pay-banner-card--pending': !payBottomBannerLoaded }"
            v-if="adConfigReady && !isCloseAD && hasPayBottomBanner && !payBottomBannerFailed"
          >
            <div class="pay-banner">
              <pay-banner-ad
                position="EXIT_ORDER_BOTTOM_BANNER"
                @loaded="payBottomBannerLoaded = true"
                @failed="payBottomBannerFailed = true"
              />
            </div>
          </div>
          <div
            class="pay-banner-card pay-banner-card--coupon"
            v-if="featureFlags.pyunCouponAd"
            :class="{ 'is-loaded': showCouponBanner }"
          >
            <div class="pay-banner pay-banner-coupon">
              <div id="pyun-ad-banner" class="pay-banner-coupon__inner"></div>
            </div>
          </div>
          <div class="pay-arrears-wrap" v-if="showArrearsPlugin">
            <div id="arrears-plugin"></div>
          </div>
        </div>
      </div>

      <div
        class="pay-footer-fixed"
        :class="{ 'pay-footer-fixed--dual': payFooterDualLayout }"
      >
        <template v-if="showPayFooterSkeleton">
          <div class="pay-footer-skeleton__btn" aria-hidden="true"></div>
          <div class="pay-footer-skeleton__btn pay-footer-skeleton__btn--wide" aria-hidden="true"></div>
        </template>
        <template v-else-if="showCouponPayBtn">
          <button
            type="button"
            class="pay-footer-btn pay-footer-btn--plain"
            :disabled="payBtnDisabled"
            @click="confirmPayDirect"
          >
            <span class="pay-footer-btn__title">立即缴费</span>
            <span class="pay-footer-btn__sub pay-footer-btn__sub--plain">{{ directPayBtnSub }}</span>
          </button>
          <button
            type="button"
            class="pay-footer-btn pay-footer-btn--coupon"
            :disabled="payBtnDisabled"
            @click="confirmPayWithCoupon"
          >
            <span class="pay-footer-btn__title">{{ pyunCouponBtnTitle }}</span>
            <span v-if="pyunCouponBtnSub" class="pay-footer-btn__sub">{{ pyunCouponBtnSub }}</span>
          </button>
        </template>
        <van-button
          v-else
          :disabled="payBtnDisabled"
          type="info"
          size="large"
          block
          @click="confirmPayDirect"
        >确认支付</van-button>
      </div>

      <div class="dialog" v-if="visible">
        <div class="dialogBox">
          <div class="dialogHead">
            优惠券
            <img src="../../assets/img/close.svg" @click="closeCouponDialog()">
          </div>
          <ul class="listBox" v-if="list.length != 0">
            <li
              class="dialogList"
              v-for="(item, index) in list"
              :key="index"
              @click.stop="getCoupons(item)"
            >
              <div>
                {{
                  item.type == couponType.money ||
                  item.type == couponType.moneyActual
                    ? '￥'
                    : ''
                }}
                <span>{{ item.all_free ? '全免' : item.value }}</span>
                {{
                  item.all_free
                    ? ''
                    : item.type == couponType.time ||
                      item.type == couponType.timeActual
                    ? '分钟'
                    : item.type == couponType.disBreaks ||
                      item.type == couponType.disBreaksActual
                    ? '折'
                    : item.type == couponType.free
                    ? '张'
                    : ''
                }}
              </div>
              <div></div>
              <div>
                <div>{{ item.typeName }}
                  </div>
                <!-- <div>适用于{{ parkname }}</div> -->
                <div>{{ item.biz_name }}</div>
                <div>领券时间：{{ item.granted_time_hms }}</div>
                <div>失效时间：{{ countUseFulTime(item) }}</div>
              </div>
              <img
                src="../../assets/img/gou1.png"
                v-show="selectid.indexOf(item.id) == -1"
              />
              <img
                src="../../assets/img/gou2.png"
                v-show="selectid.indexOf(item.id) != -1"
              />
            </li>
          </ul>
          <ul class="listBox" v-else>
            <div
              style="
                width: 100%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                font-size: 24px;
              "
            >
              无优惠劵
            </div>
          </ul>
          <div class="dialogBTN" @click="getPrice">确定</div>
        </div>
      </div>
      <!-- <div v-if="!isTypeReady" class="mask_layout" @click.stop></div> -->
    </div>

    <!-- 群蜂弹窗广告（挂到页面根节点，避免被 pay-page overflow 裁剪） -->
    <qunfeng-popup v-if="featureFlags.popupAd" ref="qunfengPopup" position-key="EXIT_ORDER_POPUP"></qunfeng-popup>
    <!-- 云纵/伯斯特 通道付弹窗 -->
    <div
      class="adDialog"
      :class="{ 'adDialog--prefetch': !showAdDialog }"
      v-if="featureFlags.popupAd && !isCloseADPopup && popupAdPrefetchMount"
    >
      <div class="adDialogBox">
        <div class="banner" style="">
          <adver position="EXIT_ORDER_POPUP"></adver>
        </div>
        <div class="adDialogFooter">
          <div class="adDialogClose" @click="closeAdDialog"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import * as mqtt from '../../api/mqtt/wsconnect'
import * as common from '../../api/common'
import * as constant from '../../api/constant'
import * as api from '../../api/api'
import * as parkService from '../../api/parkService'
import * as paycloudService from '../../api/paycloudService'
import * as util from '../../api/util'
import { Toast } from 'vant'
import adver from '../../components/Adver.vue'
import { initArrearsPlugin, fetchArrearsOrder, LICENSE_CAR_COLOR, getCarColor } from '../../api/arrearsService'
import { arrearsLogger } from '../../api/arrearsLogger'
import { arrearsAppId, arrearsParkingId, arrearsIsPaid, arrearsIsDebug } from '../../../config/arrearsConfig'
import * as pyunAdvertService from '../../api/pyunAdvertService'
import { logger } from '../../api/pyunLogger'
import { getPyunSpaceId, hasBannerSlot } from '../../../config/adConfig'
import PayBannerAd from '../../components/ads/PayBannerAd.vue'
import { featureFlags } from '../../../config/featureFlags'
import * as exitOrderPopupAd from '../../api/exitOrderPopupAd'
import * as payPageRecovery from '../../api/payPageRecovery'
import QunfengPopup from '../../components/ads/QunfengPopup.vue'
export default {
  name: 'pay_money',
  props: [],
  components: {
    adver,
    QunfengPopup,
    PayBannerAd
  },
  data () {
    return {
      featureFlags,
      btn_del: false,
      // sid: '',
      parkname: '车场',
      plate_number: '',
      parked_time: '',
      car_type: '',
      gross_price: 0,
      actually_paid: 0,
      park_pay: 0,
      payablefee: 0,
      paidfee: 0,
      havePayFee: 0, // 已支付展示
      paidfee_cash: 0,
      start_time: '',
      end_time: '',
      in_time: '',
      hour: '',
      min: '',
      seconds: '',
      sign: '',
      req_order_sn: '',
      local_info: {},
      code: '',
      appidLocal: '', // 当前sid对应的appid
      selectType: [],
      selectid: [],
      selectRuleId: [],
      selectCouponid: [],
      Price: '',
      couponPrice: '',
      couponPrice1: '',
      visible: false,
      couponType: {
        moneyActual: 11, // 减免金额
        timeActual: 12, // 减免时间
        disBreaksActual: 13, // 打折减免
        money: 1, // 减免金额
        time: 2, // 减免时间
        disBreaks: 3, // 打折减免
        free: 4 // 全免
      },
      couponTypeLabel: {
        12: '时长减免券',
        11: '金额减免券',
        13: '折扣减免券',
        4: '单次全免券',
        1: '金额减免券(券面)',
        2: '时长减免券(券面)',
        3: '折扣减免券(券面)'
      },
      list: [
        // {
        //   id: 0,
        //   typeName: '第一券',
        //   biz_name: 'yuen03商户',
        //   granted_time: '2024-12-17',
        //   expire_time: '2024-12-18',
        //   granted_time_hms: '2024-12-28 12:12:12'
        // }
      ],
      isVueReady: false,
      isTypeReady: false,
      isEmqxConnect: false,
      isPress: false,
      escapeOrder: '',
      comment: '',
      pay_channel_platform: '',
      escData: {},
      localInfo: {},
      discount_coupon_ids: [], // 查询时计算费用的优惠券id
      discount_coupon_ids_send: [], // 查询时计算费用的优惠券id 备份
      escDataTotal: '',
      tempBack: {
        expireMillSeconds: 240 * 1000,
        timeout: null,
        timestamp: 0
      },
      saveRouteQueryDataLocal: {},
      isCloseAD: false,
      adConfigReady: false,
      lastPaidTotal: '', // 已支付金额
      lastDiscoutPure: '', // 已优惠金额
      cateID: '', // 车辆类别
      b_user_selected_coupon: false,
      check_out_mode: 0,
      escapeChecked: true,
      escapeTotal: 0, // 总欠费数目
      bSupplementAll: false, // 是否追缴全部
      escapeOrderFee: 0,
      count_zero: 0, // 欠费笔数
      escapePageSize: 10, // 返回的每页查询条数
      time_start: '',
      time_end: '',
      pageTitle: '订单支付',
      onlyEscape: false, // 是否只有欠费订单金额
      tipModelCanPay: true, // 提示模式下是否允许点击支付
      showArrearsPlugin: false, // 花瓣欠费组件是否显示
      arrearsDataFetched: false, // 花瓣欠费数据是否已拉取（避免重复弹温馨提示）
      pyunAdLoaded: false, // P云广告是否加载成功
      pyunAdEnabled: false, // P云券包功能是否开启
      pyunCouponEntryEnabled: false, // Plus 且 category 为 PASSER/BENEFER 时为 true
      pyunCouponCategory: '', // Plus 子品类 PASSER | BENEFER
      pyunCouponBtnTitle: '优惠支付',
      pyunCouponBtnSub: '', // 券包支付按钮副标题（cajole_text）
      pyunCouponUiReady: true, // 券包底部按钮形态是否已判定完成
      payTopBannerLoaded: false,
      payTopBannerFailed: false,
      payBottomBannerLoaded: false,
      payBottomBannerFailed: false,
      showAdDialog: false,
      popupAdPrefetchMount: false,
      isCloseADPopup: false

    }
  },
  computed: {
    ...mapState({
      plateNumber: state => state.plateNumber.plateNumber,
      channelPath: state => state.channelPath.channelPath,
      adverInfo: state => state.adverInfo.adverInfo,
      payType: state => state.payType.payType,
      sid: state => state.sid.sid,
      saveRouteQueryData: state => state.saveRouteQueryData.saveRouteQueryData,
      appid: state => state.appid.appid,
      escapeInfo: state => state.escapeInfo.escapeInfo
    }),
    ...mapGetters(['openID']),
    showCouponBanner () {
      return this.pyunAdEnabled && this.pyunAdLoaded && this.pyunCouponEntryEnabled
    },
    mightAwaitPyunCouponFooter () {
      return featureFlags.pyunCouponAd && Number(this.payType) === common.payType.pp
    },
    showPayFooterSkeleton () {
      return this.mightAwaitPyunCouponFooter && !this.pyunCouponUiReady
    },
    payFooterDualLayout () {
      return this.showCouponPayBtn || this.showPayFooterSkeleton
    },
    showCouponPayBtn () {
      return this.pyunCouponUiReady &&
        featureFlags.pyunCouponAd &&
        this.pyunAdEnabled &&
        this.pyunAdLoaded &&
        this.pyunCouponEntryEnabled
    },
    directPayBtnSub () {
      const yuan = (Number(this.actually_paid) / 100).toFixed(2)
      return `¥${yuan}`
    },
    payBtnDisabled () {
      return !this.isTypeReady ||
        !this.isVueReady ||
        this.isPress ||
        (this.actually_paid > 0 && !this.code) ||
        !this.tipModelCanPay
    },
    hasPayTopBanner () {
      return hasBannerSlot('EXIT_ORDER_TOP_BANNER')
    },
    hasPayBottomBanner () {
      return hasBannerSlot('EXIT_ORDER_BOTTOM_BANNER')
    },
    couponDisplayText () {
      if (!this.couponPrice1 || this.couponPrice1 === '未获取到优惠券') {
        return '暂无优惠券'
      }
      return this.couponPrice1
    },
    showCouponRow () {
      const text = this.couponDisplayText
      return text !== '暂无优惠券' && text !== '未获取到优惠券'
    },
    showEscapeRow () {
      return Number(this.escapeOrderFee) > 0 || Number(this.count_zero) > 0
    },
    showPayCommentRow () {
      return !!this.comment && String(this.comment).trim() !== ''
    }
  },
  methods: {
    updatePageTitle () {
      const isParkPay = this.park_pay > 0
      const isEscapeFee = this.escapeOrderFee > 0

      if (isParkPay && !isEscapeFee) {
        this.pageTitle = '订单支付'
      } else if (!isParkPay && isEscapeFee) {
        this.pageTitle = '欠费订单支付'
      } else if (isParkPay && isEscapeFee) {
        this.pageTitle = '欠费订单支付'
      }
    },
    async query_customer_by_sid () {
      const parkInfo = await parkService.loadParkInfoAndSyncTitle(this.sid)
      if (parkInfo) {
        this.parkname = parkInfo.parkname
      }
    },
    closeAdDialog () {
      this.showAdDialog = false
    },
    getPayAuthCode () {
      return exitOrderPopupAd.getPayAuthCode(this)
    },
    tryShowChannelAdDialog (retryCount, options) {
      exitOrderPopupAd.tryShowExitOrderAd(this, retryCount, options)
    },
    escapeCheckedChange () {
      console.log('出口是否勾选逃费订单', this.escapeChecked)
      // 只有欠费： 外部订单号和欠费订单号一致；正常订单：欠费数组为[];其余 正常+欠费
      // JSON.parse(this.saveRouteQueryDataLocal.localInfo)
      // 深拷贝 防止污染
      const para = JSON.parse(JSON.stringify(this.localInfo))
      //   TODO 需要请求接口获取新的sign等字段
      if (this.escapeChecked) {
        this.actually_paid = this.park_pay + this.escapeOrderFee
        // TODO 构造local_info参数时是整个初次的message对象;更新金额fee_value
        para.fee_value = this.park_pay + this.escapeOrderFee
        // 需要补充localinfo中的欠费信息
      } else {
        this.actually_paid = this.park_pay
        // TODO 构造local_info参数时 此时欠费数据需要置空;更新金额fee_value
        para.fee_value = this.park_pay
        // 需要设置localinfo中的数组为[]
      }
      this.updateEscape(para)
    },
    async updateEscape (para) {
      this.$toast.loading({
        mask: true,
        message: '请稍候...',
        duration: 5000
      })
      try {
        const { data } = await axios({
        //   url: common.cloudPayUrl + '/pub/' + api.urlList.pay.bill.park_plate.get_self_info,
          // url: 'http://121.37.172.247:7997/api/no_sign/request.pls_req',
          url: common.reqMqCloudUrl + '/api/no_sign/request.pls_req',
          method: 'POST',
          data: {
            sid: this.sid || this.$route.query.sid,
            method: 'vh_fee_order.update_fee',
            // openid: this.openID,
            params: para
          },
          header: {
            'content-type': 'application/json' // 默认值
          }
        })
        console.log('接收到更新后的逃费信息data', data)
        // todo data.data就是后续要传的 local_info
        if (data.code === 10000 && data.data) {
          // todo判断当前是否勾选欠费订单
          console.log('Info', data.data)
          this.sign = data.data.sign
          this.local_info = data.data
          this.$toast.clear()
          const escapeInfoNew = data.data.escInfo.list[0]
          const info = data.data

          const sumDetail = data.data.escInfo.sum_detail

          const bSupplementAll = data.data.escInfo.bSupplementAll
          this.escapePageSize = data.data.escInfo.page_size
          this.bSupplementAll = bSupplementAll
          if (bSupplementAll) {
            // 追缴全部
            // 获取本次欠费笔数
            if (sumDetail && typeof sumDetail.count_zero !== 'undefined') {
              this.count_zero = Number(sumDetail.count_zero) || 0
            }
            // 获取本次欠费金额
            if (sumDetail && typeof sumDetail.total_fee_zero !== 'undefined') {
              this.escape_pay = Number(sumDetail.total_fee_zero) || 0
              this.actually_paid = Number(sumDetail.total_fee_zero)
            }
          } else {
            // 追缴最近一笔
            if (data.data.escInfo.list.length > 0) {
              this.count_zero = 1
              this.escapeOrderFee = data.data.escInfo.list[0].fee_value
            }
          }
          // // 获取本次欠费笔数
          // if (sumDetail && typeof sumDetail.count_zero !== 'undefined') {
          //   this.count_zero = Number(sumDetail.count_zero) || 0
          // }
          // // 获取本次欠费金额
          // if (sumDetail && typeof sumDetail.total_fee_zero !== 'undefined') {
          //   this.escapeOrderFee = Number(sumDetail.total_fee_zero) || 0
          // }
          //   this.escapeInfoList = data.data.list
          //   this.escapeInfoNew = escapeInfoNew
          this.vh_p_number = info.vh_p_number
          this.cateID = info.vh_cate_id
          this.comment = util.resolvePayOrderComment(info)
          this.parked_time = util.countParkTime(info.start_time, info.end_time)
          //   const localInfo = data.data.local_info
          this.in_time = info.start_time
          this.end_time = info.end_time
          this.actually_paid = Number(info.fee_value)
          // this.escapeOrderFee = Number(escapeInfoNew.fee_value)
          //   this.escape_fee_order_sn = info.fee_order_sn // 欠费金额的订单号
          //   this.local_info.fee_order_paid_esc = [info.fee_order_sn]
          // 只有欠费： 外部订单号和欠费订单号一致；正常订单：欠费数组为[];其余 正常+欠费
          if (!this.escapeChecked) {
            this.local_info.escInfo.list = []
          }
          if (!this.escapeChecked && this.actually_paid === 0 && this.escapeOrderFee > 0) {
            // 此时不允许点击确认支付
            this.tipModelCanPay = false
          } else {
            this.tipModelCanPay = true
          }
          // if (this.escapeChecked && this.actually_paid === 0 && this.escapeOrderFee > 0) {
          //   this.local_info.fee_order_sn = escapeInfoNew.fee_order_sn
          // }
        } else {
          this.$toast.clear()
          Toast(data.msg || '查询出错，请退出重新扫码')
          this.closePage()
        }
      } catch (e) {
        this.$toast.clear()
        Toast(e || '查询异常，请退出重新扫码')
        this.closePage()
      }
    },
    openEscapeOrder () {
      let needPageQryFlag = false // true则追缴全部 需要传递分页参数；false则只传递当前欠费订单即可
      if (this.bSupplementAll) {
        if (this.escDataTotal <= this.escapePageSize) {
        // 说明全部欠费数目小于每页查询条数，则不需要传递分页参数
          needPageQryFlag = false
        } else {
          needPageQryFlag = true
        }
      } else {
        needPageQryFlag = false
      }
      this.$router.push({
        path: '/vh_fee_order_escape_detail',
        query: {
          channel_path: this.channelPath,
          sid: this.sid,
          parkName: this.parkname,
          escData: JSON.stringify(this.escapeInfo.list),
          direction: 2,
          needPageQryFlag: needPageQryFlag,
          vh_p_number: this.plate_number,
          time_start: this.time_start,
          time_end: this.time_end,
        //   localInfo: JSON.stringify(this.localInfo)
        }
      })
    },
    // 车牌类别格式化 ToDo（目前生产是优先展示了临时车（包括了无牌车）。后续修改）
    plateNumFormatterCate (val, num) {
      let name = ''
      if (/^N.*/.test(num)) {
        name = '无牌车'
      } else if (Number(val) === 2) {
        name = '临时车'
      } else {
        name = '固定车'
      }
      return name
    },
    // 获取关闭广告配置
    queryADConfig () {
      const flag = util.judgeADClose({}, 2, 2)
      this.isCloseAD = flag
      if (featureFlags.popupAd) {
        const flagPopup = util.judgeADClosePopup({}, 2, 2)
        this.isCloseADPopup = flagPopup
      }
      this.adConfigReady = true
    },
    // 初始化P云券包广告（底部 banner 展示 + 支付拦截共用一次 SDK 拉取）
    async initPyunAd () {
      const mightAwait = featureFlags.pyunCouponAd && Number(this.payType) === common.payType.pp
      this.pyunCouponUiReady = !mightAwait

      if (!featureFlags.pyunCouponAd) {
        this.pyunAdEnabled = false
        return
      }
      this.pyunCouponEntryEnabled = false
      this.pyunCouponCategory = ''
      this.pyunCouponBtnTitle = ''
      this.pyunCouponBtnSub = ''
      const couponSpaceId = getPyunSpaceId('PAY_COUPON_BANNER')
      logger.info('==================== 初始化P云券包广告 (EscapeOut) ====================')
      logger.info('当前参数: sid=' + this.sid + ', openID=' + (this.openID || '(空)') + ', plate=' + (this.plate_number || '(空)') + ', amount=' + (this.actually_paid || 0) + ', payType=' + this.payType)

      try {
        if (Number(this.payType) !== common.payType.pp) {
          logger.info('当前支付方式不是PP云支付【微信】(' + this.payType + ')，跳过券包功能')
          this.pyunAdEnabled = false
          return
        }

        logger.info('步骤1: 检查券包开关...')
        try {
          const { IotService } = await import('../../api/iotService')
          const res = await IotService.getFeatureBySid(this.sid)
          logger.info('功能开关接口返回: ' + JSON.stringify(res))
          logger.info('area_code=' + (res.area_code || '(空)') + ', city_code=' + (res.city_code || '(空)'))
          if (res.info) logger.info('pyun_ad_coupon_closed: ' + JSON.stringify(res.info.pyun_ad_coupon_closed))
          this.pyunAdEnabled = IotService.isPyunAdCouponEnabled(res)
        } catch (err) {
          logger.error('❌ 获取功能开关失败: ' + err.message)
          this.pyunAdEnabled = false
        }

        logger.info('功能开关状态: pyunAdEnabled=' + this.pyunAdEnabled)

        if (!this.pyunAdEnabled) {
          logger.info('功能开关关闭，跳过SDK和广告加载')
          return
        }

        await this.$nextTick()
        await pyunAdvertService.waitForAdElement('pyun-ad-banner')
        logger.info('步骤2: 功能开关开启，加载券包广告 spaceId=' + couponSpaceId)
        const adData = await pyunAdvertService.pullAdvert({
          el: 'pyun-ad-banner',
          spaceId: couponSpaceId,
          openid: this.openID || '',
          plate: this.plate_number || '',
          tradeValue: this.actually_paid || 0,
          providerCode: this.sid,
          onReady: (e) => {
            pyunAdvertService.applyCouponPayButtonFromReady(this, e)
            logger.info('券包 ready 主标题: ' + (this.pyunCouponBtnTitle || '(空)'))
            logger.info('券包 ready 副标题: ' + (this.pyunCouponBtnSub || '(空)'))
          }
        })
        this.pyunAdLoaded = true
        logger.success('✅ P云券包广告加载成功: ' + JSON.stringify(adData))
      } catch (err) {
        this.pyunAdLoaded = false
        logger.error('❌ P云券包广告加载失败: ' + err.message)
      } finally {
        this.pyunCouponUiReady = true
        logger.info('最终广告状态: pyunAdLoaded=' + this.pyunAdLoaded + ', pyunAdEnabled=' + this.pyunAdEnabled)
      }
    },
    // 初始化花瓣欠费组件
    async initArrearsPluginHandler () {
      if (!featureFlags.huabanEscape) {
        this.showArrearsPlugin = false
        return
      }
      arrearsLogger.info('==================== 初始化花瓣欠费组件 (EscapeOut) ====================')
      arrearsLogger.info('当前参数: sid=' + this.sid + ', openID=' + (this.openID || '(空)') + ', plate=' + (this.plate_number || '(空)'))

      try {
        const { IotService } = await import('../../api/iotService')
        const res = await IotService.getFeatureBySid(this.sid)
        if (!IotService.isHuabanEscapeEnabled(res)) {
          arrearsLogger.info('花瓣欠费在关闭时间段内，跳过初始化')
          this.showArrearsPlugin = false
          return
        }

        // 清理之前的残留参数
        localStorage.removeItem('arrears_callback_escape_out')

        // 存储当前页面参数，用于回调恢复
        const pageParams = {
          sid: this.sid,
          channel_path: this.channelPath,
          plate_number: this.plate_number,
          // 存储 EscapeOut 页面恢复所需的关键参数
          saveRouteQueryDataLocal: this.saveRouteQueryDataLocal,
          escapeInfo: this.escapeInfo,
          timestamp: Date.now() // 添加时间戳
        }
        localStorage.setItem('arrears_callback_escape_out', JSON.stringify(pageParams))
        arrearsLogger.info('已存储回调参数')

        // 初始化插件 - callbackURL 指向当前页面，只带 sid 和 channel_path
        arrearsLogger.info('调用 initArrearsPlugin...')
        const callbackURL = window.location.origin + '/#/vh_fee_order_escape_out?sid=' + (this.sid || 'yuen03') + '&channel_path=-1'
        arrearsLogger.info('callbackURL:', callbackURL)

        const plugin = await initArrearsPlugin({
          appId: arrearsAppId,
          openId: this.openID || '',
          parkingId: this.sid || arrearsParkingId,
          isPaid: arrearsIsPaid,
          isDebug: arrearsIsDebug,
          callbackURL: callbackURL
        })

        arrearsLogger.info('initArrearsPlugin 返回:', plugin)
        arrearsLogger.info('返回类型:', typeof plugin)

        this.showArrearsPlugin = true
        arrearsLogger.info('✅ 组件初始化成功，showArrearsPlugin=' + this.showArrearsPlugin)

        // 查询欠费数据
        if (this.plate_number) {
          arrearsLogger.info('车牌号已准备好，开始查询欠费数据...')
          await this.fetchArrearsData()
        } else {
          arrearsLogger.info('车牌号为空，等待后续查询')
        }
      } catch (err) {
        arrearsLogger.error('❌ 组件初始化失败', err)
        arrearsLogger.error('错误信息:', err.message)
        arrearsLogger.error('错误堆栈:', err.stack)
        this.showArrearsPlugin = false
      }
    },
    // 查询花瓣欠费数据
    async fetchArrearsData () {
      if (!this.showArrearsPlugin) {
        arrearsLogger.info('花瓣欠费组件未启用，跳过查询')
        return
      }
      if (this.arrearsDataFetched) {
        arrearsLogger.info('花瓣欠费数据已拉取，跳过重复查询（避免温馨提示重复弹出）')
        return
      }

      arrearsLogger.info('==================== 查询欠费数据 (EscapeOut) ====================')
      arrearsLogger.info('车牌号:', this.plate_number)
      arrearsLogger.info('cateID:', this.cateID)

      if (!this.plate_number) {
        arrearsLogger.warn('⚠️ 车牌号为空，跳过查询')
        return
      }

      try {
        // 获取车牌颜色
        const carColor = getCarColor(this.plate_number, this.cateID)
        arrearsLogger.info('车牌颜色:', carColor)

        // 查询欠费数据
        arrearsLogger.info('调用 fetchArrearsOrder...')
        const result = await fetchArrearsOrder(this.plate_number, carColor)

        arrearsLogger.info('✅ 查询完成')
        arrearsLogger.info('返回数据:', JSON.stringify(result, null, 2))
        this.arrearsDataFetched = true

        // 插件会自动渲染到 #arrears-plugin 容器
      } catch (err) {
        arrearsLogger.error('❌ 查询失败', err)
        arrearsLogger.error('错误信息:', err.message)
        arrearsLogger.error('错误堆栈:', err.stack)
      }
    },
    plateNumFormatter (para) {
      return para.length < 8
        ? '常规车'
        : /^N.*/.test(para)
          ? '临时车'
          : '能源车'
    },
    getCoupons (row) {
      console.log('getCoupons', row)
      if (row) {
        const rowType = Number(row.type)
        if (this.selectType.length === 0) {
          this.selectType.push(row.type)
          this.selectCouponid.push(row.coupon_id)
          this.selectid.push(row.id)
          this.selectRuleId.push(row.rule_id)
          if (rowType === this.couponType.money || rowType === this.couponType.time) {
            this.couponPrice = row.value
          } else if (rowType === this.couponType.disBreaks) {
            this.couponPrice1 = row.value + '折'
          } else if (rowType === this.couponType.free) {
            this.couponPrice1 = '全免'
          } else {
            if (row.all_free) {
              this.couponPrice1 = '全免'
            } else {
              if (rowType === this.couponType.moneyActual || rowType === this.couponType.timeActual) {
                this.couponPrice = row.value
              } else if (rowType === this.couponType.disBreaksActual) {
                this.couponPrice1 = row.value + '折'
              }
            }
          }
        } else if (rowType === this.couponType.disBreaks || rowType === this.couponType.free) {
          if (this.selectid.indexOf(row.id) !== -1) {
            this.selectid.forEach((val, index) => {
              if (val === row.id) {
                this.selectid.splice(index, 1)
                this.selectType.splice(index, 1)
                this.selectRuleId.splice(index, 1)
                this.selectCouponid.splice(index, 1)

                this.couponPrice = ''
              }
            })
          } else {
            this.$toast('该类型优惠券无法叠加')
          }
          // eslint-disable-next-line no-mixed-operators
        } else if (rowType === this.couponType.disBreaksActual || row.all_free &&
          (rowType === this.couponType.moneyActual || rowType === this.couponType.timeActual)) {
          if (this.selectid.indexOf(row.id) !== -1) {
            this.selectid.forEach((val, index) => {
              if (val === row.id) {
                this.selectid.splice(index, 1)
                this.selectType.splice(index, 1)
                this.selectRuleId.splice(index, 1)
                this.selectCouponid.splice(index, 1)
                this.couponPrice = ''
              }
            })
          } else {
            this.$toast('该类型优惠券无法叠加')
          }
        } else if (this.selectType.indexOf(row.type) === -1) {
          this.$toast('请选择相同类型的优惠券')
        } else if (this.selectType.indexOf(row.type) !== -1) {
          if (this.selectid.indexOf(row.id) !== -1) {
            this.selectid.forEach((val, index) => {
              if (val === row.id) {
                this.selectid.splice(index, 1)
                this.selectType.splice(index, 1)
                this.selectRuleId.splice(index, 1)
                this.selectCouponid.splice(index, 1)
                this.couponPrice -= row.value
              }
            })
          } else {
            var length = row.allowed_used_onetime_self ? row.allowed_used_onetime_self : 99
            if (this.selectid.length >= length) {
              this.$toast('已超出叠加限制')
            } else {
              this.selectType.push(row.type)
              this.selectid.push(row.id)
              this.selectCouponid.push(row.coupon_id)
              this.selectRuleId.push(row.rule_id)
              this.couponPrice += row.value
            }
          }
        }
        if (this.couponPrice <= 0 && (rowType === this.couponType.money || rowType === this.couponType.time)) {
          this.couponPrice1 = '未使用优惠券'
        } else if (rowType === this.couponType.money || (!row.all_free && rowType === this.couponType.moneyActual)) {
          this.couponPrice1 = '-' + Number(this.couponPrice).toFixed(2) + '元'
        } else if (rowType === this.couponType.time || (!row.all_free && rowType === this.couponType.timeActual)) {
          this.couponPrice1 = '-' + this.couponPrice + '分钟'
        }
      } else {
        this.$toast.fail('获取券值出错了')
      }
    },
    unsubscribe: function (action, callback) {
      // 订阅
      const topic = `/ypt/u_${this.sid}/${encodeURIComponent(this.plate_number)}`
      const options = {
        payload: {
          topic: action,
          plate_number: this.plate_number
        }
      }
      mqtt.unsubscribe(topic, options, function (err, granted) {
        if (err) {
          callback(err, granted)
          return
        }
        callback(null, granted)
      })
    },
    getTempBackTimeout () {
      const ms = this.tempBack.expireMillSeconds
      if (!this.tempBack.timestamp) this.tempBack.timestamp = new Date().getTime()
      // console.log('tempBack.timestamp', this.tempBack.timestamp)
      this.tempBack.timeout = setTimeout(() => {
        this.expireGoBack()
        this.clearBackTimeout()
      }, ms)
    },
    clearBackTimeout () {
      clearTimeout(this.tempBack.timeout)
      this.tempBack.timeout = null
    },
    expireGoBack () {
      this.tempBack.timestamp = 0
      this.$dialog.alert({
        // showCancelButton: true,
        title: '支付超时',
        message: '点击“确认”后重新付款'
      }).then(() => {
        this.onClickLeft()
      })
    },
    confirmPayDirect () {
      this.runConfirmPay(false)
    },
    redirectToPayGateway (url) {
      payPageRecovery.redirectToPaymentGateway(
        this,
        payPageRecovery.PAY_GATEWAY_REDIRECT_KEYS.ESCAPE_OUT,
        url
      )
    },
    clearPayRedirectMarkersLocal () {
      payPageRecovery.clearPayRedirectMarkers([
        payPageRecovery.PAY_GATEWAY_REDIRECT_KEYS.ESCAPE_OUT,
        pyunAdvertService.PYUN_COUPON_REDIRECT_KEYS.ESCAPE_OUT
      ])
    },
    sweepPayRedirectMarkersLocal () {
      payPageRecovery.sweepPayRedirectMarker(payPageRecovery.PAY_GATEWAY_REDIRECT_KEYS.ESCAPE_OUT)
      payPageRecovery.sweepPayRedirectMarker(pyunAdvertService.PYUN_COUPON_REDIRECT_KEYS.ESCAPE_OUT)
    },
    confirmPayWithCoupon () {
      this.runConfirmPay(true)
    },
    confirmPay: async function () {
      this.runConfirmPay(false)
    },
    runConfirmPay: async function (withPyunCoupon) {
      if (new Date().getTime() - this.tempBack.timestamp > this.tempBack.expireMillSeconds) {
        this.clearBackTimeout()
        return this.expireGoBack()
      }
      if (this.actually_paid > 0 && !this.code) {
        this.getAllCode()
        return
      }
      this.isPress = true
      if (parseFloat(this.gross_price) <= 0) {
        this.$toast('收费 0 元')
        // return
      }
      const that = this
      // let payType = this.$Storejs.getItem('payType');
      try {
        // if (payType == common.payType.wx || payType == common.payType.zfb) {
        //   //直连支付、农行微信支付
        //   if (that.actually_paid > 0) {
        //     if (!this.code) {
        //       this.getAllCode()
        //       return
        //     }
        //   }
        // // }
        // if (payType == common.payType.abc) { // 农行微信支付
        //   if (that.actually_paid > 0) {
        //     if (!this.code) {
        //       this.getAllCode()
        //       return
        //     }
        //   }
        // }
        // 除了支付为0元，所有支付都要获取code
        if (that.actually_paid > 0) {
          if (!this.code) {
            this.getAllCode()
            return
          }
        }

        if (!this.isVueReady) {
          return this.$toast('努力加载中.')
        } else if (!this.isTypeReady) {
          if (common.getUserAgent() === 'wx') {
            return this.$toast('微信努力加载中.')
          } else {
            return this.$toast('支付宝努力加载中.')
          }
        } else if (!this.isEmqxConnect) {
          const client = await this.init_mqtt()

          if (client && client.connected) {
            await this.subscribe('sq')
            doPay(withPyunCoupon)
            return
          } else {
            throw (new Error('网络中断...'))
          }
        }
        doPay(withPyunCoupon)
      } catch (e) {
        console.log(e)
        this.$toast.fail('请求失败')
      }

      function doPay (usePyunCoupon) {
        that.local_info.discount_coupon_ids = that.selectCouponid
        that.local_info.discount_rule_id = that.selectRuleId
        that.local_info.discount_rule_type = that.selectType[0]
        const obj = {
          sid: that.sid,
          gross_price: parseFloat(that.gross_price),
          actually_paid: parseFloat(that.actually_paid),
          // req_order_sn: that.req_order_sn,
          sign: that.sign,
          code: that.code || 'invalid',
          plate_number: that.plate_number,
          subject: (that.parkname ? that.parkname + ' ' : '') + that.plate_number + '停车收费',
          start_time: that.start_time,
          end_time: that.end_time,
          local_info: that.local_info,
          is_xcx: false
        }

        // ============ P云广告拦截逻辑 ============
        if (usePyunCoupon && featureFlags.pyunCouponAd && that.pyunAdEnabled && that.pyunAdLoaded && that.pyunCouponEntryEnabled) {
          logger.info('[EscapeOut] 执行P云广告拦截')
          const couponSpaceId = getPyunSpaceId('PAY_COUPON_BANNER')
          pyunAdvertService.interceptAdvert(async (event) => {
            logger.info('[EscapeOut] 广告拦截回调', event)
            if (event.action === 'REDIRECT') {
              // 用户确认购买券包，调用 getPayargs 获取 pay_id
              that.$toast.loading({
                mask: true,
                message: '正在生成订单...',
                duration: 10000
              })

              try {
                if (that.actually_paid > 0 && !that.code) {
                  that.isPress = false
                  that.getAllCode()
                  return
                }
                logger.info('[EscapeOut] 调用 getPayargs 获取 pay_id', obj)

                // 调用已有的 getPayargs 方法
                const payargs = await parkService.getPayargs(
                  obj,
                  null,
                  Number(that.payType),
                  Number(that.local_info.pay_channel_platform),
                  common.getUserAgent() === 'wx'
                )

                that.$toast.clear()
                logger.info('[EscapeOut] getPayargs 返回', payargs)

                if (payargs && payargs.pay_id) {
                  // 拿到 pay_id，传给 SDK 跳转
                  logger.info('[EscapeOut] ✅ 获取到 pay_id', payargs.pay_id)
                  pyunAdvertService.markPyunCouponRedirect(
                    pyunAdvertService.PYUN_COUPON_REDIRECT_KEYS.ESCAPE_OUT,
                    that.plate_number
                  )
                  that.isPress = false
                  const redirectParams = await paycloudService.getPyunCouponRedirectParams(
                    that.sid,
                    payargs.pay_id
                  )
                  logger.info('[EscapeOut] 券包跳转参数', redirectParams)
                  event.redirect(redirectParams)
                } else {
                  // 没有 pay_id，走原支付流程
                  logger.warn('[EscapeOut] ⚠️ 未获取到 pay_id，走原支付流程')
                  doOriginalPay('')
                }
              } catch (err) {
                that.$toast.clear()
                logger.error('[EscapeOut] ❌ 获取 pay_id 失败', err.message)
                doOriginalPay('')
              }
            } else {
              // 用户取消券包，走原支付流程
              logger.info('[EscapeOut] 用户取消券包，走原支付流程')
              doOriginalPay('')
            }
          }, true, couponSpaceId)
          return
        }

        // 不走券包，直接走原支付流程
        doOriginalPay('')

        function doOriginalPay (payargs) {
          that.$toast.loading({
            mask: true,
            message: '请稍候...',
            duration: 5000
          })
          parkService.getPayargs(obj, null, that.payType, that.local_info.pay_channel_platform, common.getUserAgent() === 'wx')
          .then(payargs => {
            that.$toast.clear()
            that.selectid = []
            that.selectType = []
            that.selectRuleId = []
            if (parseFloat(that.actually_paid) <= 0) {
              that.isPress = true
              that.$toast({
                type: 'success',
                message: '支付0元',
                duration: 3000,
                forbidClick: true
              })
              setTimeout(function () {
                if (common.getUserAgent() === 'wx') {
                  // eslint-disable-next-line no-undef
                  WeixinJSBridge.call('closeWindow')
                } else if (common.getUserAgent() === 'zfb') {
                  // eslint-disable-next-line no-undef
                  ap.popWindow()
                }
              }, 3000)
            } else {
              that.isPress = false
              if (common.getUserAgent() === 'wx') {
                that.wxReadyToPay(payargs)
              } else if (common.getUserAgent() === 'zfb') {
                that.do_zfb_pay(payargs)
              }
            }
          })
          .catch(e => {
            that.$toast.clear()
            that.isPress = false
            if (parseFloat(that.actually_paid) > 0) {
              console.log(e)
              that.$dialog.alert({
                title: `错误码：${e.code || '未知'}`,
                message: e.message || '支付失败'
              }).then(() => {
                that.onClickLeft()
              })
            } else that.$toast.clear()
          })
        }
      }
    },
    ZFBReady (callback) {
      if (window.AlipayJSBridge) {
        callback && callback()
      } else {
        if (document.addEventListener) {
          document.addEventListener('AlipayJSBridgeReady', callback, false)
        } else if (document.attachEvent) {
          document.attachEvent('AlipayJSBridgeReady', callback)
        }
      }
    },
    do_zfb_pay (payargs) {
      const that = this
      this.ZFBReady(function () {
        const payType = that.payType
        if (payType === common.payType.zfb) { // 支付宝直联
          // eslint-disable-next-line no-undef
          ap.tradePay({
            tradeNO: payargs.tradeNo
          }, function (res) {
            if (res && (res.resultCode === '9000' || res.resultCode === 9000)) {
              that.isPress = true
              that.doCloseAll()
              if (common.adverType === '2') {
                // eslint-disable-next-line no-undef
                AlipayJSBridge.call('pushWindow', {
                  url: 'https://bo111.yuntingiot.com/api/ac/477786592149311488',
                  param: {
                    backBehavior: 'pop',
                    closeCurrentWindow: true
                  }
                })
              }
            } else {
              that.$dialog.alert({
                title: '支付失败'
              }).then(() => {
                // ToDo 暂时将支付宝失败时关闭应用处理，后续优化
                // that.onClickLeft()
                that.doCloseAll()
              })
            }
          })
        } else if (payType === common.payType.bjyz_zfb) { // 支付宝云纵间联
          const pars = {
            start_time: that.start_time,
            hour: that.hour,
            min: that.min,
            seconds: that.seconds,
            actually_paid: that.actually_paid,
            couponPrice1: that.couponPrice1,
            invoice_url: payargs.invoice_url,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.plate_number
          }
          console.log('zfb 云纵', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)
          that.redirectToPayGateway(payargs.trade_url)
        } else if (payType === common.payType.pp_zfb) { // 支付宝PP间联
          const pars = {
            start_time: that.start_time,
            hour: that.hour,
            min: that.min,
            seconds: that.seconds,
            actually_paid: that.actually_paid,
            couponPrice1: that.couponPrice1,
            invoice_url: payargs.invoice_url,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.plate_number
          }
          console.log('zfb pp', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)
          that.redirectToPayGateway(payargs.pay_url)
        } else if (payType === common.payType.icbc_zfb) { // 工商支付宝间联
          const pars = {
            start_time: that.start_time,
            hour: that.hour,
            min: that.min,
            seconds: that.seconds,
            actually_paid: that.actually_paid,
            couponPrice1: that.couponPrice1,
            invoice_url: payargs.invoice_url,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.plate_number
          }
          console.log('工商 zfb', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)
          that.redirectToPayGateway(payargs.pay_url)
        } else if (payType === common.payType.abc_zfb) { // 支付宝农行间联
          if (payargs.tradeNo) {
            // eslint-disable-next-line no-undef
            ap.tradePay({
              tradeNO: payargs.tradeNo
            }, function (res) {
              if (res && (res.resultCode === '9000' || res.resultCode === 9000)) {
                that.isPress = true
                that.doCloseAll()
                if (common.adverType === '2') {
                // eslint-disable-next-line no-undef
                  AlipayJSBridge.call('pushWindow', {
                    url: 'https://bo111.yuntingiot.com/api/ac/477786592149311488',
                    param: {
                      backBehavior: 'pop',
                      closeCurrentWindow: true
                    }
                  })
                }
              } else {
                that.$dialog.alert({
                  title: '支付失败'
                }).then(() => {
                // ToDo 暂时将支付宝失败时关闭应用处理，后续优化
                // that.onClickLeft()
                  that.doCloseAll()
                })
              }
            })
          } else {
            const pars = {
              start_time: that.start_time,
              hour: that.hour,
              min: that.min,
              seconds: that.seconds,
              actually_paid: that.actually_paid,
              couponPrice1: that.couponPrice1,
              invoice_url: payargs.invoice_url,
              sid: that.sid,
              parkName: that.parkName,
              plateNumber: that.plate_number
            }
            console.log('zfb 农行', pars)
            that.$store.commit(constant.keyAdverInfoVuex, pars)

            that.redirectToPayGateway(payargs.pay_url)
          }
        } else if (payType === common.payType.lanzhoubank_zfb) { // 支付宝兰州间联
          const pars = {
            start_time: that.start_time,
            hour: that.hour,
            min: that.min,
            seconds: that.seconds,
            actually_paid: that.actually_paid,
            couponPrice1: that.couponPrice1,
            // invoice_url: payargs.invoice_url,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.plate_number
          }
          that.$store.commit(constant.keyAdverInfoVuex, pars)

          that.redirectToPayGateway(payargs.billQRCode)
        } else if (payType === common.payType.ningbobank_zfb) { // 支付宝宁波银行间联
          const pars = {
            start_time: that.start_time,
            hour: that.hour,
            min: that.min,
            seconds: that.seconds,
            actually_paid: that.actually_paid,
            couponPrice1: that.couponPrice1,
            // invoice_url: payargs.invoice_url,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.plate_number
          }
          console.log('zfb 宁波银行', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)

          that.redirectToPayGateway(payargs.pay_url)
        }
      })
    },
    async get_open_url (payWay, sid, plateNumber, tempQueryParams) {
      const result = await paycloudService.getOpenUrl(payWay, sid, plateNumber, tempQueryParams, 'payMoney')
      if (result) {
        this.$store.commit(constant.keyPayTypeVuex, result.pay_type)
        return result.open_url
      } else {
        return Promise.reject(new Error('获取支付跳转URL失败'))
      }
    },
    doCloseAll () {
      if (common.getUserAgent() === 'wx') {
        // this.closeWindowWX()
      } else if (common.getUserAgent() === 'zfb') {
        this.closeWindowZfb()
      }
    },
    closeWindowZfb () {
      if (window.AlipayJSBridge) {
        close()
      } else {
        if (document.addEventListener) {
          document.addEventListener('AlipayJSBridgeReady', close(), false)
        } else if (document.attachEvent) {
          document.attachEvent('AlipayJSBridgeReady', close())
        }
      }
      function close () {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('closeWebview')
      }
    },
    onClickLeft () {
      this.goHome()
    },
    goHome () {
      this.clearPayRedirectMarkersLocal()
      sessionStorage.setItem('fromPayPage', 'true')
      this.$router.replace({
        path: '/index',
        query: {
          sid: this.sid,
          channel_path: this.channelPath
        }
      })
    },
    async getAppId () {
      const appId = await paycloudService.getAppIdWx(this.sid)
      if (appId) {
        this.appidLocal = appId
        this.$store.commit(constant.keyAppIDVuex, appId)
        return this.appidLocal
      } else {
        return Promise.reject(new Error('获取AppID失败'))
      }
    },
    async getZFBAppId () {
      const appIdData = await paycloudService.getAppIdZfb(this.sid)
      if (appIdData) {
        this.appidLocal = appIdData.auth_app_id
        this.$store.commit(constant.keyAppIDVuex, appIdData.app_id)
        return this.appidLocal
      } else {
        return Promise.reject(new Error('获取支付宝AppID失败'))
      }
    },

    onBridgeReady (payargs) {
      var that = this

      const payType = this.payType
      if (payType === common.payType.wx) { // 微信直联
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: payargs.appId != null ? payargs.appId : that.appid, // 公众号名称，由商户传入
            timeStamp: payargs.timeStamp || payargs.timestamp, // 时间戳，自1970年以来的秒数
            nonceStr: payargs.nonceStr || payargs.nonce_str, // 随机串
            package: payargs.package,
            signType: payargs.signType != null ? payargs.signType : 'MD5', // 微信签名方式：
            paySign: payargs.paySign || payargs.sign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // that.$toast.success('支付完成')
              // // that.$router.replace('/index')
              // that.$router.replace({
              //   path: '/index',
              //   query:{
              //     sid: this.$Storejs.getItem('sid'),
              //     channel_path: this.$Storejs.getItem('channel_path')
              //   }
              // })
              // that.$toast({
              //   type: 'success',
              //   message: '支付完成',
              //   duration: 0,
              //   forbidClick: true
              // })
              window.location.replace('https://pa03.yuntingiot.com/api/ac/477786592149311488')
              // WeixinJSBridge.call('closeWindow')
            } else {
              that.isPress = false
              that.$dialog.alert({
                // showCancelButton: true,
                title: '支付失败'
              }).then(() => {
                payPageRecovery.resumePayOnOrderPage(that)
              })
            }
          })
      } else if (payType === common.payType.bjyz) { // 微信云纵间联
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          invoice_url: payargs.invoice_url,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }
        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.redirectToPayGateway(payargs.trade_url)
        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.pp) { // 微信PP间联
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.redirectToPayGateway(payargs.pay_url)
        // pay_url: "https://auth.4pyun.com/authorize?scope=snsapi_base&redirect_uri=https%3A%2F%2Fapp.4pyun.com%2Fpayment%2Ftrade%2Fcreate%3Fpay_id%3D983768955900399617"

        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.icbc) { // 工商微信间联
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.redirectToPayGateway(payargs.pay_url)
        // pay_url: "https://auth.4pyun.com/authorize?scope=snsapi_base&redirect_uri=https%3A%2F%2Fapp.4pyun.com%2Fpayment%2Ftrade%2Fcreate%3Fpay_id%3D983768955900399617"

        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.abc) { // 微信农行间联
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }

        that.$store.commit(constant.keyAdverInfoVuex, pars)

        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: payargs.appId != null ? payargs.appId : that.appid, // 公众号名称，由商户传入
            timeStamp: payargs.timeStamp || payargs.timestamp, // 时间戳，自1970年以来的秒数
            nonceStr: payargs.nonceStr || payargs.nonce_str, // 随机串
            package: payargs.package,
            signType: payargs.signType != null ? payargs.signType : 'MD5', // 微信签名方式：
            paySign: payargs.paySign || payargs.sign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // that.$toast.success('支付完成')
              // // that.$router.replace('/index')
              // that.$router.replace({
              //   path: '/index',
              //   query:{
              //     sid: this.$Storejs.getItem('sid'),
              //     channel_path: this.$Storejs.getItem('channel_path')
              //   }
              // })
              // that.$toast({
              //   type: 'success',
              //   message: '支付完成',
              //   duration: 0,
              //   forbidClick: true
              // })
              window.location.replace('https://pa03.yuntingiot.com/api/ac/477786592149311488')
              // WeixinJSBridge.call('closeWindow')
            } else {
              that.isPress = false
              that.$dialog.alert({
                // showCancelButton: true,
                title: '支付失败'
              }).then(() => {
                payPageRecovery.resumePayOnOrderPage(that)
              })
            }
          })
      } else if (payType === common.payType.lanzhoubank) { // 兰州银行微信
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }

        that.$store.commit(constant.keyAdverInfoVuex, pars)

        this.redirectToPayGateway(payargs.billQRCode)
      } else if (payType === common.payType.ningbobank) { // 宁波银行微信
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.redirectToPayGateway(payargs.pay_url)
      }
    },
    wxReadyToPay (payargs) {
      var that = this
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          // console.log('vv 111')
          document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady(payargs), false)
        } else if (document.attachEvent) {
          // console.log('vv 222')
          document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady(payargs))
          document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady(payargs))
        }
      } else {
        // console.log('vv 333')
        that.onBridgeReady(payargs)
      }
    },
    strToDate (dateObj) {
      if (dateObj) {
        dateObj = dateObj.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/')
        if (dateObj.indexOf('.') > 0) dateObj = dateObj.slice(0, dateObj.indexOf('.'))
        return new Date(dateObj)
      } else {
        return ''
      }
    },
    Price1 () {
      // this.visible=true
      console.log('点击了优惠券', this.channelPath)
      if (Number(this.channelPath) !== -1) {
        if (!/^N.*/.test(this.plate_number)) {
          // this.$toast('有牌车通道码不支持优惠券')
          // return
        }
        //  允许无牌车通道码选择优惠券
        // console.log('QQQQQ')
      }

      this.$toast.loading({
        forbidClick: true,
        message: '请稍候...',
        duration: 3000
      })
      const price1 = true
      this.get_coupon(price1)
    },
    countUseFulTime (item) {
      if (!item.expire_time) return ''
      if (new Date(item.expire_time).getFullYear() >= 2999) {
        return '长期'
      } else {
        return common.format(item.expire_time, 'yyyy-M-dd hh:mm:ss')
      }
    },
    async get_coupon (visible) {
      console.log('get_coupon', visible)
      try {
        const { CouponService } = await import('../../api/couponService')
        const res = await CouponService.getCouponListByVehicle({
          sid: this.sid,
          vh_p_number: this.plate_number,
          page_no: 1,
          page_size: 1000,
          status: 1
        })
        this.$toast.clear()
        console.log('get_coupon---', res)
        if (res.code && res.code === 10000) {
        if (res.list && res.list.length) {
          if (visible === true) {
            // this.$toast()
            // this.$toast.close();

            this.visible = true
          }
          res.list.forEach((val, index) => {
            val.typeName = this.couponTypeLabel[val.type]
            if (val.all_free) {
              val.typeName += '(全免)'
            }
            if (val.type === this.couponType.money ||
              val.type === this.couponType.moneyActual) {
              val.value /= 100
            } else if (val.type === this.couponType.time) {
            } else if (val.type === this.couponType.disBreaks ||
              val.type === this.couponType.disBreaksActual) {
              val.value /= 10
            } else if (val.type === this.couponType.free) {
            }
            // val.expire_time = common.format(val.expire_time, 'yyyy-M-dd')
            val.granted_time_hms = common.format(val.granted_time, 'yyyy-M-dd hh:mm:ss')
            // val.granted_time = common.format(val.granted_time, 'yyyy-M-dd')
            // if(index == 0){
            //   this.selectType.push(val.type)
            //   this.selectid.push(val.coupon_id)
            //   this.selectRuleId.push(val.rule_id)
            //   if(val.type == this.couponType.money){
            //     this.couponPrice1 = '-' + val.value + '元'
            //   }else if(val.type == this.couponType.time){
            //     this.couponPrice1 = '-' + val.value + '分钟'
            //   }else if(val.type == this.couponType.disBreaks){
            //     this.couponPrice1 = val.value + '折'
            //   }else if(val.type == this.couponType.free){
            //     this.couponPrice1 = '全免'
            //   }
            // }
          })
          this.$nextTick(() => {
            console.log('优惠券列表', res.list)
            this.list = res.list
            if (!visible) {
              // 判断是否为通道付 是的话 根据收费信息中的优惠券列表来勾选对应的优惠券
              console.log('这是通道付时计算费用包含的优惠券id', this.discount_coupon_ids)
              if (this.discount_coupon_ids.length > 0) {
                // 遍历列表，检查计算费用的 coupon_id 是否在 discount_coupon_ids 中
                const isAnyCouponUsed = this.list.some(item =>
                  this.discount_coupon_ids.includes(item.coupon_id)
                )
                if (!isAnyCouponUsed) {
                  this.couponPrice1 = '未使用优惠券'
                } else {
                  this.list.forEach(item => {
                    if (this.discount_coupon_ids.includes(item.coupon_id)) {
                    // 如果匹配到优惠券 ID，则调用 getCoupons 方法
                      this.getCoupons(item)
                    }
                  })
                }
              } else {
                this.couponPrice1 = '未使用优惠券'
              }

              // this.getPrice()
            }
          })
        } else {
          this.couponPrice1 = '未获取到优惠券'
        }
      } else {
        this.$toast.fail('获取优惠券失败，请重试')
      }
      return res
    } catch (error) {
      console.error('获取优惠券失败:', error)
      this.$toast.fail('获取优惠券异常，请重试')
      return null
    }
  },
    async queryOrder () { // 查询车牌订单
      var that = this
      // const plateNumber = this.plate_number
      that.$toast.loading({
        mask: true,
        message: '请稍候...',
        duration: 3000
      })
      try {
        await that.init_mqtt()
        await that.subscribe('sq')
      } catch (e) {
        console.log(e)
        // this.$toast.fail(e)
        throw e
      }
    },
    subscribe: async function (action, callback) {
      // 订阅
      const topic = `/ypt/u_${this.sid}/${encodeURIComponent(this.plate_number)}`
      const options = {
        payload: {
          topic: action,
          plate_number: this.plate_number,
          channel_path: this.channelPath || -1
        }
      }
      // console.log('mqtt', mqtt)
      await mqtt.subscribe(topic, options)
    },
    async init_mqtt (cb) {
      var that = this
      // var utils = util
      const config = {
        onConnected: function () {
          that.isEmqxConnect = true
        },
        // onReconnect: that.subscribe,
        onMessage: this.getFQResult
      }

      const client = await mqtt.getClient(config)
      if (client && client.connected) {
        client.callback.fq = this.getFQResult
        return client
      } else {
        that.$toast.fail('NetWork err!')
        throw new Error('client NetWork err!')
      }
    },
    getFQResult: async function (topic, message, packet) {
      console.log('getFQResult123', message)
      // this.$dialog.alert({
      //   title: '支付111',
      //   message: JSON.stringify(message)
      // }).then(() => {
      // })
      const that = this
      if (message instanceof Uint8Array) message = JSON.parse(message.toString()) // 收到的信息
      // console.log('payMessage', message)
      if (message && message.code !== common.resCode.OK) {
        return that.$toast(message.msg || '查询费用出错')
      }
      that.local_info = {
        ...message,
        sid: this.sid,
        plate_number: message.plate_number,
        start_time: message.start_time,
        end_time: message.end_time,
        customer_id: message.customer_id,
        wks_id: message.wks_id,
        operator_id: message.operator_id,
        channel_path: this.channelPath,
        vh_p_number: message.plate_number,
        vh_pnull_number: message.vh_pnull_number,
        state: message.state,
        payablefee: message.payablefee,
        paidfee: message.paidfee,
        havePayFee: message.havePayFee,
        discount: message.discount,
        fee_rule_id: message.fee_rule_id,
        discount_rule_id: message.discount_rule_id,
        vh_in_id: message.vh_in_id,
        vh_out_id: message.vh_out_id,
        parked_time: message.parked_time,
        vh_cate_id: message.vh_cate_id,
        payType: message.payType,
        pay_channel: message.pay_channel,
        fee_value: message.fee_value,
        fee_order_sn: message.fee_order_sn,
        discount_coupon_values: message.discount_coupon_values,
        discount_coupon_sources: message.discount_coupon_sources,
        pay_channel_platform: message.pay_channel_platform
      }
      const plateNumber = that.plate_number // 输入的车牌
      console.log('plateNumber', plateNumber)
      console.log('message.plate_number', message.plate_number)
      console.log('message.fee_value', message.fee_value)
      if (decodeURIComponent(message.plate_number) === plateNumber) {
        that.$toast.clear()
        if (isNaN(Number(message.fee_value)) || message.fee_value == null) {
          that.$toast(message.msg || '计算费用失败')
          // return
        }
        that.actually_paid = message.fee_value
        // TODO 同时更新 停车金额 和停车时长
        that.payablefee = message.payablefee
        // that.parked_time = util.parkTimeformat(message.parked_time)
        const startTime = message.start_time
        const endTime = message.end_time
        this.parked_time = util.countParkTime(startTime, endTime)
        // 更新场内已支付和城内已优惠金额
        this.lastPaidTotal = message.last_paid_total || message.has_paid_fee_value || 0
        this.lastDiscoutPure = message.last_discout_pure || message.has_discount_pure || 0
        const commentText = util.resolvePayOrderComment(message)
        if (commentText) {
          that.comment = commentText
        }
        // 判断此时的计算费用的优惠券id
        if (message.discount_coupon_ids.length === 0) {
          this.couponPrice1 = '未使用优惠券'
        }
        that.visible = false
      }
    },
    // 用户点击关闭 优惠券弹窗
    closeCouponDialog () {
      // 取消之后，还是按照原来的优惠券进行勾选 不改变已选中的优惠券

      if (this.discount_coupon_ids_send.length > 0) {
        this.selectType = []
        this.selectCouponid = []
        this.selectid = []
        this.selectRuleId = []
        // 比较row的coupon_id是否在this.discount_coupon_ids中 是的话 勾选
        this.list.forEach(item => {
          if (this.discount_coupon_ids_send.includes(item.coupon_id)) {
            this.getCoupons(item)
          }
        })
      } else {
        this.couponPrice1 = '未使用优惠券'
        this.selectType = []
        this.selectCouponid = []
        this.selectid = []
        this.selectRuleId = []
      }
      this.visible = false
    },
    // 用户选择优惠券点击确定
    async getPrice () {
      // 只针对 通道付情况
      if (this.channelPath !== -1) {
      // 确定后 判断 选择的优惠券id和保存的优惠券id是否一致 一致则return 否则重新查询
        const arrSeamFlag = util.areArraysIdentical(this.selectCouponid, this.discount_coupon_ids_send)
        if (arrSeamFlag) {
        // 同时 关闭优惠券弹窗
          this.visible = false
          this.b_user_selected_coupon = false
          return
        }
        this.b_user_selected_coupon = true
      }
      // 确认后，覆盖初始化的优惠券id列表
      this.discount_coupon_ids_send = [...this.selectCouponid]//
      try {
        await this.queryOrder()
      } catch (e) {
        this.$toast.fail('查询费用出错')
        return
      }

      const data = {
        sid: this.sid,
        plate_number: this.plate_number,
        channel_path: this.channelPath,
        discount_coupon_ids: this.selectCouponid,
        version: 'v2',
        b_user_selected_coupon: this.b_user_selected_coupon
      }

      axios({
        url: common.cloudParkingUrl + '/s2p/' + api.urlList.queryPrice,
        method: 'POST',
        data: data,
        header: {
          'content-type': 'application/json' // 默认值
        }
      }).then(res => {
        if (res.data.code && res.data.code === 10000) {
          // this.$toast.loading({
          //   mask: true,
          //   message: '请稍候...',
          //   // duration: 10000
          // });
          // mqtt.getClient()
          this.visible = false
        } else {
          this.$toast(common.resMSG[res.data.code])
        }
      })
    },
    WX_Bridge_ready (cb) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', cb(), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', cb())
          document.attachEvent('onWeixinJSBridgeReady', cb())
        }
      } else {
        cb()
      }
    },
    getAllCode () {
      if (this.getPayAuthCode()) {
        exitOrderPopupAd.syncPayAuthCode(this)
        exitOrderPopupAd.tryShowExitOrderAd(this, 0, {
          allowDirectCode: true,
          delayMs: 2000
        })
        return
      }
      if (common.getUserAgent() === 'wx') {
        this.getAppId().then(appid => {
          console.log('当前页面的Query参数', this.$route.query)
          exitOrderPopupAd.saveUrlQueryForCodeObtain(this)
          exitOrderPopupAd.markPendingExitOrderAd(this.plate_number)

          const target = new URL(window.location.origin + '/#/vh_fee_order_escape_out')
          target.searchParams.set('plate_number', this.plate_number)

          const toUrl = common.getCodeObtainUrl(target, appid, true)

          console.log('拼接后的短跳转链接', toUrl)
          window.location.href = toUrl
        }).catch(e => {
          this.$toast('网络错误')
        })
      } else if (common.getUserAgent() === 'zfb') {
        if (!this.code) {
          this.getZFBAppId().then(appid => {

            window.location.href = common.getCodeObtainUrl(window.location, appid, false)
          }).catch(e => {
            this.$toast('网络错误')
          })
        }
      }
      // console.log('22222222222222')
    },
    unsubscribeAndClose () {
      this.unsubscribe('sq', function (err, granted) {
        console.log('退订', err, granted)
        mqtt.close()
      })
      this.clearBackTimeout()
    }
  },
  filters: {
    filterVH (num) {
      const reg = /^N.*/
      if (reg.test(num)) {

      }
    },
    filterClass (num) {
      const reg = /^N.*/
      if (num.length < 8) {

      }
      if (reg.test(num)) {

      }
    },
    filterTime (time) {
      try {
        if (time) {
          return common.format(time, 'yyyy-MM-dd hh:mm:ss')
        } else {
          return '无入场时间'
        }
      } catch (e) {
        return '不支持的时间格式'
      }
    },
    filterTimeShort (time) {
      try {
        if (time) {
          return common.format(time, 'MM-dd hh:mm:ss')
        }
        return '-'
      } catch (e) {
        return '-'
      }
    },
    formatParkDuration (str) {
      return util.formatParkDurationDisplay(str)
    }
  },
  watch: {
    '$route.query.code' (val) {
      if (val) {
        exitOrderPopupAd.syncPayAuthCode(this)
        exitOrderPopupAd.tryShowExitOrderAd(this, 0, { allowDirectCode: true, delayMs: 1000 })
      }
    },
    '$route.query.auth_code' (val) {
      if (val) {
        exitOrderPopupAd.syncPayAuthCode(this)
        exitOrderPopupAd.tryShowExitOrderAd(this, 0, { allowDirectCode: true, delayMs: 1000 })
      }
    }
  },
  created () {
    console.log('来到了vh_fee_order_escape_out created', this.$route.query)

    // 检查花瓣欠费回调 - 恢复页面参数（在 created 中执行，确保后续逻辑能使用恢复的参数）
    const arrearsCallback = localStorage.getItem('arrears_callback_escape_out')
    if (arrearsCallback) {
      try {
        const params = JSON.parse(arrearsCallback)
        localStorage.removeItem('arrears_callback_escape_out')

        // 检查时间戳，超过 10 分钟认为过期
        const isValid = params.timestamp && (Date.now() - params.timestamp < 10 * 60 * 1000)
        if (!isValid) {
          console.log('花瓣回调参数已过期，忽略')
        } else {
          console.log('检测到花瓣回调参数，恢复页面状态:', params)

          // 不恢复 code，因为 code 有效期只有 5 分钟，花瓣支付过程可能超过这个时间
          // 让 getAllCode 重新获取新的 code
          this.code = ''
          this.$store.commit(constant.keyCodeVuex, '')

          // 恢复 saveRouteQueryDataLocal
          if (params.saveRouteQueryDataLocal) {
            this.saveRouteQueryDataLocal = params.saveRouteQueryDataLocal
            sessionStorage.setItem(constant.keySaveRouteQueryDataVuex, JSON.stringify(params.saveRouteQueryDataLocal))
          }
          // 恢复 escapeInfo
          if (params.escapeInfo) {
            this.$store.commit(constant.keyEscapeVuex, params.escapeInfo)
          }
          // 恢复其他参数
          if (params.plate_number) {
            this.plate_number = params.plate_number
          }
        }
      } catch (e) {
        console.error('解析花瓣回调参数失败:', e)
        localStorage.removeItem('arrears_callback_escape_out')
      }
    }

    // 保存初次进来时的 query，授权回流时合并 session 缓存，避免覆盖完整订单参数
    this.saveRouteQueryDataLocal = util.resolveSaveRouteQueryData(
      this.$route.query,
      constant.keySaveRouteQueryDataVuex
    )

    // console.log('wx还是支付宝', common.getUserAgent())
    if (common.getUserAgent() === 'wx') {
      this.code = this.$route.query.code || this.saveRouteQueryDataLocal.code
    } else if (common.getUserAgent() === 'zfb') {
      this.code = this.$route.query.auth_code || this.saveRouteQueryDataLocal.auth_code
    }
    exitOrderPopupAd.syncPayAuthCode(this)

    const s1 = (new Date(this.strToDate(this.saveRouteQueryDataLocal.start_time || this.saveRouteQueryDataLocal.end_time))).getTime()
    const s2 = (new Date(this.strToDate(this.saveRouteQueryDataLocal.end_time))).getTime()
    // console.log(s1, s2)

    console.log('this.saveRouteQueryDataLocal', this.saveRouteQueryDataLocal)

    const total = (s2 - s1) / 1000
    const hour = parseInt(total / (60 * 60))
    const afterHour = total - hour * 60 * 60 // 取得算出小时数后剩余的秒数
    const min = parseInt(afterHour / 60)
    const seconds = total - hour * 60 * 60 - min * 60

    this.plate_number = this.saveRouteQueryDataLocal.plate_number
    this.$store.commit(constant.keyPlateNumberVuex, this.saveRouteQueryDataLocal.plate_number)
    this.gross_price = this.saveRouteQueryDataLocal.gross_price
    // console.log('this.saveRouteQueryDataLocal.localInfo', this.saveRouteQueryDataLocal.localInfo)
    this.actually_paid = JSON.parse(this.saveRouteQueryDataLocal.localInfo).fee_value
    this.payablefee = JSON.parse(this.saveRouteQueryDataLocal.localInfo).payablefee
    console.log('打印本次停车金额actually_paid', this.actually_paid)
    console.log('打印本次停车金额payablefee', this.payablefee)
    this.paidfee = JSON.parse(this.saveRouteQueryDataLocal.localInfo).paidfee
    this.havePayFee = JSON.parse(this.saveRouteQueryDataLocal.localInfo).havePayFee

    this.comment = util.resolvePayOrderComment(JSON.parse(this.saveRouteQueryDataLocal.localInfo))
    this.paidfee_cash = JSON.parse(this.saveRouteQueryDataLocal.localInfo).paidfee_cash === undefined ? 0 : JSON.parse(this.saveRouteQueryDataLocal.localInfo).paidfee_cash
    this.req_order_sn = this.saveRouteQueryDataLocal.req_order_sn
    this.start_time = this.saveRouteQueryDataLocal.start_time
    this.end_time = this.saveRouteQueryDataLocal.end_time
    this.sign = this.saveRouteQueryDataLocal.sign
    this.hour = hour
    this.min = min
    this.seconds = seconds
    this.local_info = JSON.parse(this.saveRouteQueryDataLocal.localInfo)
    if (!this.local_info.channel_path) {
      this.local_info.channel_path = -1
    }
    // this.sid = this.sid
    // 初始化时 计算了几个优惠券 则勾选几个优惠券
    this.discount_coupon_ids = JSON.parse(this.saveRouteQueryDataLocal.localInfo).discount_coupon_ids || []
    this.discount_coupon_ids_send = JSON.parse(this.saveRouteQueryDataLocal.localInfo).discount_coupon_ids || []
    // this.selectCouponid = JSON.parse(this.saveRouteQueryDataLocal.localInfo).discount_coupon_ids
    this.tempBack.timestamp = this.saveRouteQueryDataLocal.receive_timestamp || new Date().getTime()

    this.lastPaidTotal = JSON.parse(this.saveRouteQueryDataLocal.localInfo).last_paid_total || JSON.parse(this.saveRouteQueryDataLocal.localInfo).has_paid_fee_value || 0
    this.lastDiscoutPure = JSON.parse(this.saveRouteQueryDataLocal.localInfo).last_discout_pure || JSON.parse(this.saveRouteQueryDataLocal.localInfo).has_discount_pure || 0
    this.cateID = JSON.parse(this.saveRouteQueryDataLocal.localInfo).vh_cate_id

    this.init_mqtt().catch(e => {
      Toast.fail('请检查网络,支付查询失败')
    })
    const cachedParkName = parkService.restoreParkBrowserTitleFromCache()
    if (cachedParkName) {
      this.parkname = cachedParkName
    }
    this.query_customer_by_sid()
  },
  mounted () {
    this.sweepPayRedirectMarkersLocal()
    payPageRecovery.recoverFromGatewayPayRedirect(
      payPageRecovery.PAY_GATEWAY_REDIRECT_KEYS.ESCAPE_OUT,
      this
    )
    if (featureFlags.pyunCouponAd) {
      pyunAdvertService.recoverFromPyunCouponRedirect(
        pyunAdvertService.PYUN_COUPON_REDIRECT_KEYS.ESCAPE_OUT,
        this
      )
    }
    console.log('@@@@@@@@@@', this.$route.query)
    console.log('@@@@@@@@@@saveRouteQueryDataLocal', this.saveRouteQueryDataLocal)

    this.queryADConfig()

    // 初始化花瓣欠费组件
    if (featureFlags.huabanEscape) {
      this.initArrearsPluginHandler()
    }

    this.pay_channel_platform = this.saveRouteQueryDataLocal.pay_channel_platform
    this.sign = this.saveRouteQueryDataLocal.sign

    // this.$store.commit(constant.keySaveRouteQueryDataVuex, this.saveRouteQueryDataLocal)

    // 判断是否有欠费订单和当前支付订单
    // 根据接受参数对象 判断有无欠费订单
    // console.log('this.saveRouteQueryDataLocal.escape_info', this.saveRouteQueryDataLocal.escape_info)
    // console.log('this.saveRouteQueryDataLocal.local_info', this.saveRouteQueryDataLocal.local_info)
    // const escData = this.$route.query.escape_info ? JSON.parse(this.saveRouteQueryDataLocal.escape_info) : null
    const escData = util.parseEscapeInfo(this.escapeInfo, this.saveRouteQueryDataLocal.escape_info)
    if (escData && !this.escapeInfo) {
      this.$store.commit(constant.keyEscapeVuex, escData)
    }
    const localInfo = JSON.parse(this.saveRouteQueryDataLocal.localInfo)
    console.log('escData', escData)
    console.log('localInfo', localInfo)
    this.localInfo = localInfo
    // this.sid = localInfo.sid
    this.pay_channel = localInfo.pay_channel
    this.plate_number = this.saveRouteQueryDataLocal.plate_number
    // this.parked_time = util.parkTimeformat(JSON.parse(this.saveRouteQueryDataLocal.localInfo).parked_time)
    const startTime = JSON.parse(this.saveRouteQueryDataLocal.localInfo).start_time
    const endTime = JSON.parse(this.saveRouteQueryDataLocal.localInfo).end_time
    this.parked_time = util.countParkTime(startTime, endTime)
    this.check_out_mode = Number(JSON.parse(this.saveRouteQueryDataLocal.localInfo).check_out_mode)

    this.isVueReady = false

    // console.log('欠费订单', escData)
    // const escData = util.parseIfJSONString(escDataLocal)
    // test 欠费订单数量
    // escData.total = 2
    // 本次停车费用
    this.park_pay = JSON.parse(this.saveRouteQueryDataLocal.localInfo).fee_value

    console.log('欠费订单 last', escData)
    if (typeof escData === 'object' && escData) {
      this.check_out_mode = escData.check_out_mode
      console.log('欠费订单', escData)
      this.escData = escData
      this.time_start = escData.time_start
      this.time_end = escData.time_end
      this.escapeTotal = escData.total
      this.bSupplementAll = escData.bSupplementAll
      const sumDetail = escData.sum_detail
      if (this.bSupplementAll) {
        // 获取本次欠费笔数
        if (sumDetail && typeof sumDetail.count_zero !== 'undefined') {
          this.count_zero = Number(sumDetail.count_zero) || 0
        }
        // 获取本次欠费金额
        if (sumDetail && typeof sumDetail.total_fee_zero !== 'undefined') {
          this.escapeOrderFee = Number(sumDetail.total_fee_zero) || 0
        }
      } else {
        if (escData.list && escData.list.length > 0) {
          this.count_zero = 1
          this.escapeOrderFee = escData.list[0].fee_value
        }
      }
      // if (escData.list && escData.list.length > 0) {
      //   this.escapeOrderFee = escData.list[0].fee_value
      // }
    }
    const isParkPay = this.park_pay > 0
    const isEscapeFee = this.escapeOrderFee > 0

    this.onlyEscape = !isParkPay && isEscapeFee
    this.actually_paid = this.park_pay + this.escapeOrderFee

    this.updatePageTitle()
    if (isParkPay && !isEscapeFee) {
      this.actually_paid = this.park_pay
      this.onlyEscape = false
    } else if (!isParkPay && isEscapeFee) {
      this.actually_paid = this.escapeOrderFee
      this.onlyEscape = true
    } else if (isParkPay && isEscapeFee) {
      this.onlyEscape = false
    }

    this.tempQueryParams = {
      plate_number: this.plate_number,
      gross_price: parseFloat(this.gross_price),
      actually_paid: parseFloat(this.actually_paid),
      req_order_sn: this.req_order_sn,
      start_time: this.start_time,
      end_time: this.end_time,
      sign: this.sign,
      hour: this.hour,
      min: this.min,
      seconds: this.seconds,
      local_info: this.local_info,
      sid: this.sid,
      appid: this.appid,
      auth_code: this.saveRouteQueryDataLocal.auth_code
    }

    let payWay = common.payWay.weichat
    if (common.getUserAgent() === 'wx') {
      payWay = common.payWay.weichat
    } else if (common.getUserAgent() === 'zfb') {
      payWay = common.payWay.alipay
    }
    // return
    // console.log('sidsid', this.sid)
    this.get_open_url(payWay, this.sid, this.plate_number, this.tempQueryParams).then((openUrl) => {
      // console.log('fffff')

      // payType 已设置，初始化P云广告和券包功能
      if (featureFlags.pyunCouponAd) {
        this.initPyunAd()
      }

      if (this.actually_paid > 0) {
        this.getAllCode()
      } else if (this.actually_paid === 0 && escData && escData.total > 0) {
        this.getAllCode()
      } else if (this.actually_paid === 0) {
        if (this.discount_coupon_ids_send.length > 0) {
          this.getAllCode()
        }
      }
      this.get_coupon()
    })

    const that = this
    this.isVueReady = true
    // console.log('微信还是支付宝', common.getUserAgent())
    if (common.getUserAgent() === 'wx') {
      this.WX_Bridge_ready(() => {
        setButtonClertload()
      })
    } else if (common.getUserAgent() === 'zfb') {
      this.ZFBReady(() => {
        setButtonClertload()
      })
    }

    function setButtonClertload () {
      that.$nextTick(() => {
        that.isTypeReady = true
      })
    }
    this.getTempBackTimeout()
    exitOrderPopupAd.syncPayAuthCode(this)
    this.$store.commit(constant.keyCodeVuex, this.code)
    exitOrderPopupAd.prefetchExitOrderPopup(this)
    exitOrderPopupAd.scheduleExitOrderPopup(this)

    if (featureFlags.pyunCouponAd) {
      this._pyunCouponRedirectHandlers = pyunAdvertService.bindPyunCouponRedirectListeners(
        pyunAdvertService.PYUN_COUPON_REDIRECT_KEYS.ESCAPE_OUT,
        this
      )
    }
    this._gatewayPayRedirectHandlers = payPageRecovery.bindGatewayPayRedirectListeners(
      payPageRecovery.PAY_GATEWAY_REDIRECT_KEYS.ESCAPE_OUT,
      this
    )
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'payEscape') {
      next()
    } else {
      this.clearPayRedirectMarkersLocal()
      this.unsubscribeAndClose()
      next()
    }
  },
  beforeDestroy () {
    pyunAdvertService.unbindPyunCouponRedirectListeners(this._pyunCouponRedirectHandlers)
    payPageRecovery.unbindGatewayPayRedirectListeners(this._gatewayPayRedirectHandlers)
    // urlQueryInfo:${plate_number}`
    const { plate_number } = this.saveRouteQueryDataLocal
    localStorage.removeItem(`urlQueryInfo:${this.plate_number}`)
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/css/pay-order-page.scss';

.mainBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.container {
  margin-top: 0.22rem;
  padding: 0 0.3rem;
}

.mask_layout {
  z-index: 9999;
  background-color: transparent;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.row1 {
  display: flex;
  align-items: center;
  justify-content: left;
}

.row1 .number {
  font-size: 0.22rem;
  font-weight: bold;
  margin-right: 0.06rem;
}

.row1 .normal {
  font-size: 0.16rem;
  padding: 0.01rem 0.04rem;
  background: #f4f4f4;
  border-radius: 0.12rem;
}

.row1 .special {
  font-size: 0.16rem;
  padding: 0.01rem 0.04rem;
  color: #7eab4c;
  background: #e9f9dc;
  border-radius: 0.12rem;
}

.row2 {
  margin-top: 0.36rem;
  text-align: center;
  font-size: 0.16rem;
}

.row3 {
  margin-top: 0.12rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.row3 .code {
  font-size: 0.28rem;
  color: #333;
  font-weight: bold;
  margin-right: 0.06rem;
}

.row3 .number {
  font-size: 0.42rem;
  color: #333;
  font-weight: bold;
}

.row4 {
  margin-top: 0.24rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 0.01rem solid #ededed;
  border-bottom: 0.01rem solid #ededed;
}

.row4 .time-tip {
  color: #999;
  font-size: 0.14rem;
}

.row4 .in-time {
  color: #333;
  font-size: 0.16rem;
}

.row5,
.row6 {
  margin-top: 0;
  border-top: none;
}

.row5 > .couponPrice {
  display: flex;
  align-items: center;
  font-size: 0.14rem;
  font-weight: bold;
  color: rgba(238, 38, 10, 1);
}
.couponPrice img {
}

.row6 > .time-tip {
  font-size: 0.14rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.row6 {
  border-bottom: none;
  margin-top: 23px;
}

.row6 > .price {
  font-size: 0.24rem;
  font-weight: bold;
  color: rgba(255, 62, 0, 1);
}

.button-row-pay {
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  font-size: 0.1rem;
  z-index: 10000;
}

.dialogBox {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70%;
  background: #fff;
  padding: 0.2rem 0.12rem 0;
  box-sizing: border-box;
  z-index: 10001;
}

.dialogHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.16rem;
  margin-bottom: 0.18rem;
  font-weight: bold;
}

.dialogHead > img {
  width: 0.2rem;
  height: 0.2rem;
}

.listBox {
  height: 72%;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
}

.listBox::-webkit-scrollbar {
  display: none;
}

.dialogList {
  display: flex;
  align-items: center;
  border: 1px solid #d5d5d5;
  height: 0.94rem;
  margin-bottom: 0.1rem;
}

.dialogList > div:first-child {
  color: #ee260a;
  font-size: 0.18rem;
  width: 33%;
  text-align: center;
}

.dialogList > div:first-child span {
  font-size: 0.32rem;
}

.dialogList > div:nth-child(2) {
  height: 0.6rem;
  border-left: 1px solid rgba(228, 223, 223, 1);
  margin-right: 0.18rem;
}

.dialogList > div:nth-child(3) {
  margin-right: 0.1rem;
}

.dialogList > div:nth-child(3) > div:first-child {
  font-size: 0.14rem;
  color: #333333;
  margin-bottom: 0.04rem;
  font-weight: bold;
  margin-left: .2667rem;
}

.dialogList > div:nth-child(3) > div {
  /* margin-bottom: 0.06rem; */
  margin-bottom: 0.025rem;
  color: #909090;
  text-align: left;
}
.dialogList .showBizName{
  font-size: 0.12rem;
  color: #333333;
  margin-left: 5px;
}

.dialogBTN {
  width: 3.17rem;
  height: 0.5rem;
  background: rgba(71, 151, 234, 1);
  border-radius: 2px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
  margin: 0.18rem auto 0;
}

/* add */
.commentBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.01rem solid #ededed;
  padding: 0.15rem 0;
  /* border-bottom: none; */
  /* height: 1rem ; */
  /* height: 100%; */
  /* line-height: .5rem; */
}
.comment-time-tip {
  color: #999;
  font-size: 0.14rem;
}
.comment-in-time {
  max-width: 250px;
  text-align: right;
  line-height: 0.2rem;
  font-size: 0.14rem !important;
}

/* 广告弹窗样式 */
.adDialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.4rem;
  box-sizing: border-box;
}

.adDialogBox {
  position: relative;
  width: 100%;
  max-width: 5.6rem;
  border-radius: 0.32rem;
  overflow: hidden;
}

.adDialogFooter {
  width: 100%;
  padding: 0.1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 0.32rem 0.32rem;
  position: relative;
}

.adDialogClose {
  width: 0.56rem;
  height: 0.56rem;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
  border: 0.04rem solid #ffd700;
  box-sizing: border-box;
  background: transparent;
}

.adDialogClose::before,
.adDialogClose::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0.32rem;
  height: 0.04rem;
  background: #ffd700;
  transform-origin: center;
  border-radius: 999px;
}

.adDialogClose::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.adDialogClose::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.adDialog .banner {
  width: 100%;
}
</style>
